import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles/index.css";

// Errors only (OD-30). VITE_SENTRY_DSN / VITE_ENVIRONMENT are baked in at build time by
// deploy-web.yml; with no DSN the SDK is never initialised. `environment` comes from the deploy
// (dev|prod), NOT import.meta.env.MODE, which is "production" for every vite build and made
// SunshineBids' dev and prod web events indistinguishable (its S229).
// Sentry 11 replaced `sendDefaultPii: false` with `dataCollection`, whose defaults collect
// everything; the PII-bearing categories are turned off explicitly (mirrors apps/api/src/index.ts).
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_ENVIRONMENT ?? "local",
    release: __APP_VERSION__,
    tracesSampleRate: 0,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpBodies: [],
      graphQL: { document: false, variables: false },
      genAI: { inputs: false, outputs: false },
      mcp: { inputs: false, outputs: false },
      databaseQueryData: false,
      queues: false,
      stackFrameVariables: false,
    },
  });
}

const root = document.getElementById("root");
if (!root) throw new Error("#root missing from index.html");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
